import { AppConfig } from '../config';
import { Api } from '../lib/api';

const apiConfig = {
  returnRejectedPromiseOnError: true,
  withCredentials: false,
  timeout: 30000,
  baseURL: AppConfig.apiBaseURL,
  headers: {
    common: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  },
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ApiService = new Api(apiConfig as any);

export default ApiService;
